import { createSlice } from "@reduxjs/toolkit";

const pagodecomisionesState = {
  pagodecomisionesdata: [],
};

const pagodecomisionesSlice = createSlice({
  name: "pagodecomisiones",
  initialState: pagodecomisionesState,
  reducers: {
    PagoDeComisionesData: (state, actions) => actions.payload,
    CleanPagoDeComisionesData: () => pagodecomisionesState,
  },
});

export const { PagoDeComisionesData, CleanPagoDeComisionesData } = pagodecomisionesSlice.actions;

export default pagodecomisionesSlice.reducer;